import type { DispatchRecordStatus } from '@rematter/frontend-lib-api-client';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type DispatchRecordEntry = QueryAtomResult<
  typeof queryDispatchRecordsAtom
>[number];

export const queryDispatchRecordsAtom = createQueryAtomFactory(
  'settings.dispatchRecords',
  (params: {
    governmentReportingConfigurationId?: string;
    facilityId?: string;
    status?: DispatchRecordStatus[];
    batchId?: string;
  }) => ({
    complianceDispatchRecords: {
      __args: {
        filter: {
          governmentReportingConfigurationId:
            params.governmentReportingConfigurationId,
          facilityId: params.facilityId,
          status: params.status,
          batchId: params.batchId,
        },
        sorting: ['CreatedAtDesc' as const],
        pagination: {
          offset: 0,
          limit: 100,
        },
      },
      entries: {
        id: true,
        facilityId: true,
        batchId: true,
        governmentReportingConfigurationId: true,
        purchaseLoadId: true,
        dispatchType: true,
        status: true,
        submittedAt: true,
        externalReferenceId: true,
        errorMessage: true,
        errorType: true,
        isRetriable: true,
        retryCount: true,
        maxRetryCount: true,
        nextRetryAt: true,
        facility: {
          id: true,
          facilityName: true,
        },
        governmentReportingConfiguration: {
          id: true,
          name: true,
          serviceType: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) =>
      data?.complianceDispatchRecords.entries.map((record) => ({
        id: record.id,
        facilityId: record.facilityId,
        batchId: record.batchId,
        governmentReportingConfigurationId:
          record.governmentReportingConfigurationId,
        purchaseLoadId: record.purchaseLoadId,
        dispatchType: record.dispatchType,
        status: record.status,
        submittedAt: record.submittedAt,
        externalReferenceId: record.externalReferenceId,
        errorMessage: record.errorMessage,
        errorType: record.errorType,
        isRetriable: record.isRetriable,
        retryCount: record.retryCount,
        maxRetryCount: record.maxRetryCount,
        nextRetryAt: record.nextRetryAt,
        facilityName: record.facility?.facilityName ?? '',
        configName: record.governmentReportingConfiguration?.name ?? '',
        serviceType: record.governmentReportingConfiguration?.serviceType ?? '',
        createdAt: record.timestamps.createdAt,
        updatedAt: record.timestamps.updatedAt,
      })) ?? [],
  },
);
